














































































import { Vue, Component } from "@/shared/vuepack";
import Button from "@/shared/components/ui/Button.vue";
import { useBalanceTransferStore } from "@/employee/store/balanceTransfer";
import Checkbox from "@/shared/components/ui/Checkbox.vue";

@Component({
  components: {
    Button,
    Checkbox
  }
})
export default class TrusteeToTrusteeTransferDetails extends Vue {
  balanceTransferStore = useBalanceTransferStore();

  get nextDisabled () {
    return this.$validator.errors.any();
  }

  onTransferEntireBalanceChanged () {
    this.balanceTransferStore.trusteeToTrusteeDetails.transferEntireBalance = !this.balanceTransferStore.trusteeToTrusteeDetails.transferEntireBalance;
    if (this.balanceTransferStore.trusteeToTrusteeDetails.transferEntireBalance && this.balanceTransferStore.trusteeToTrusteeDetails.transferPartialBalance) {
      this.balanceTransferStore.trusteeToTrusteeDetails.transferPartialBalance = false;
      this.balanceTransferStore.trusteeToTrusteeDetails.amount = 0;
    }
  }

  onTransferPartialBalanceChanged () {
    this.balanceTransferStore.trusteeToTrusteeDetails.transferPartialBalance = !this.balanceTransferStore.trusteeToTrusteeDetails.transferPartialBalance;
    if (this.balanceTransferStore.trusteeToTrusteeDetails.transferEntireBalance && this.balanceTransferStore.trusteeToTrusteeDetails.transferPartialBalance) {
      this.balanceTransferStore.trusteeToTrusteeDetails.transferEntireBalance = false;
    }
  }

  goBack () {
    this.balanceTransferStore.goToStart();
  }

  onSubmit () {
    this.$validator.validate()
      .then(isValid => {
        if (!isValid) {
          return;
        }

        this.balanceTransferStore.goToStep("trustee-download");
      });
  }
}
